import { PageId } from 'constants/pages'
import { getHasBasicSubscription } from 'helpers/getHasBasicSubscription'
import { getIntellioResumeTarget } from 'helpers/getIntellioResumeTarget'
import type { TStep } from 'src/types'
import { useZustandGlobalStore } from 'zustandGlobalStore'

// Paid and registered intl_hlwn70 users resume on the LearnWorlds redirect page
// instead of the report page that follows it, even after they already left for
// the platform once.
export const getIntellioHlwn70ResumeTarget = (pages: TStep[]): PageId => {
  const resumeTarget = getIntellioResumeTarget({
    pages,
    pageIds: {
      certificate: PageId.CERTIFICATE_INTL_HLWN70,
      nameEntry: PageId.NAME_ENTRY_INTL_HLWN70,
      offer: PageId.OFFER_INTL_HLWN70,
      registration: PageId.REGISTRATION_INTL_HLWN70,
      report: PageId.REPORT_INTL_HLWN70,
    },
  })

  if (resumeTarget !== PageId.REPORT_INTL_HLWN70) return resumeTarget

  const { lead } = useZustandGlobalStore.getState()
  const hasSubscription = getHasBasicSubscription(lead?.subscriptions || null)
  const hasAccount = !!lead?.firebaseToken

  return hasSubscription && hasAccount
    ? PageId.LEARNWORLDS_REDIRECT_INTL_HLWN70
    : resumeTarget
}
